import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, withKeys as _withKeys, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5471da8c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Ny rapport", -1))
const _hoisted_3 = { class: "label-sm block mb-6" }
const _hoisted_4 = {
  key: 0,
  class: "field-error"
}
const _hoisted_5 = { class: "flex gap-4 dates" }
const _hoisted_6 = { class: "label-sm block mb-6" }
const _hoisted_7 = {
  key: 0,
  class: "field-error"
}
const _hoisted_8 = { class: "label-sm block mb-6" }
const _hoisted_9 = {
  key: 0,
  class: "field-error"
}
const _hoisted_10 = { class: "label-sm block mb-6" }
const _hoisted_11 = {
  key: 0,
  class: "field-error"
}
const _hoisted_12 = { class: "label-sm block" }
const _hoisted_13 = {
  key: 0,
  class: "field-error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RfpCategorySelect = _resolveComponent("RfpCategorySelect")!
  const _component_PeoplePicker = _resolveComponent("PeoplePicker")!
  const _component_MarkdownEditor = _resolveComponent("MarkdownEditor")!
  const _component_RfpMeasures = _resolveComponent("RfpMeasures")!
  const _component_SvgIcon = _resolveComponent("SvgIcon")!
  const _component_HcButton = _resolveComponent("HcButton")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Card, { class: "p-6" }, {
      default: _withCtx(() => [
        _hoisted_2,
        _createElementVNode("form", null, [
          _createElementVNode("label", _hoisted_3, [
            _createTextVNode(" Tittel "),
            _withDirectives(_createElementVNode("input", {
              class: "form-input block w-full",
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.title) = $event))
            }, null, 512), [
              [_vModelText, _ctx.form.title]
            ]),
            (_ctx.form.errors.title)
              ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.form.errors.title), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("label", _hoisted_6, [
              _createTextVNode(" Dato for hendelse "),
              _withDirectives(_createElementVNode("input", {
                class: "form-input block w-full",
                type: "date",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.occured_at) = $event))
              }, null, 512), [
                [_vModelText, _ctx.form.occured_at]
              ]),
              (_ctx.form.errors.occured_at)
                ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.form.errors.occured_at), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("label", _hoisted_8, [
              _createTextVNode(" Må behandles og lukkes innen "),
              _withDirectives(_createElementVNode("input", {
                class: "form-input block w-full",
                type: "date",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.deadline) = $event))
              }, null, 512), [
                [_vModelText, _ctx.form.deadline]
              ]),
              (_ctx.form.errors.deadline)
                ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_ctx.form.errors.deadline), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("label", _hoisted_10, [
            _createTextVNode(" Kategorier "),
            _createVNode(_component_RfpCategorySelect, {
              modelValue: _ctx.form.category_ids,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.category_ids) = $event)),
              categories: _ctx.categories
            }, null, 8, ["modelValue", "categories"]),
            (_ctx.form.errors.category_ids)
              ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(_ctx.form.errors.category_ids), 1))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_PeoplePicker, {
            class: "mb-6",
            label: "Deltakere",
            placeholder: "Søk på navn, epost, tlf eller id",
            errorMessage: _ctx.form.errors.participant_ids,
            options: _ctx.users,
            modelValue: _ctx.form.participant_ids,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.participant_ids) = $event))
          }, null, 8, ["errorMessage", "options", "modelValue"]),
          _createVNode(_component_PeoplePicker, {
            class: "mb-6",
            label: "Tildelt",
            placeholder: "Søk på navn, epost, tlf eller id",
            errorMessage: _ctx.form.errors.assigned_ids,
            options: _ctx.users,
            modelValue: _ctx.form.assigned_ids,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.assigned_ids) = $event))
          }, null, 8, ["errorMessage", "options", "modelValue"]),
          _createElementVNode("label", _hoisted_12, [
            _createTextVNode(" Detaljert beskrivelse av hendelsen "),
            _createVNode(_component_MarkdownEditor, {
              editorOptions: {
              min_height: 450,
            },
              modelValue: _ctx.form.description,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.description) = $event))
            }, null, 8, ["modelValue"]),
            (_ctx.form.errors.description)
              ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(_ctx.form.errors.description), 1))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_RfpMeasures, {
            class: "measures measures-proposed",
            mode: "edit",
            title: "Forslag til tiltak",
            modelValue: _ctx.form.measures,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.measures) = $event)),
            error: _ctx.form.errors.measures
          }, null, 8, ["modelValue", "error"]),
          _createVNode(_component_HcButton, {
            onClick: _ctx.send,
            onKeyup: _withKeys(_ctx.send, ["enter"]),
            class: "mt-6",
            color: "green"
          }, {
            default: _withCtx(() => [
              (_ctx.form.processing)
                ? (_openBlock(), _createBlock(_component_SvgIcon, {
                    key: 0,
                    class: "animate-spin mr-2",
                    type: "mdi",
                    path: _ctx.loadingIcon
                  }, null, 8, ["path"]))
                : _createCommentVNode("", true),
              _createTextVNode(" Send ")
            ]),
            _: 1
          }, 8, ["onClick", "onKeyup"])
        ])
      ]),
      _: 1
    })
  ]))
}